<div class="flex flex-wrap">
  <div *ngIf="loading" class="bg-gray-300 container flex justify-center items-center ml-12 mr-12 mb-16 mt-16" style="border-radius: 12px;">
    <mat-spinner
      class="loading-spinner mb-4 mt-4"
      [color]="color"
      [diameter]="diameter"
    >
    </mat-spinner>
  </div>
  <router-outlet></router-outlet>
</div>

<div class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
  <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
  <img *ngIf="!hidePgLogo" class="sm:h-12 h-10 mr-2 mb-0 sm:mr-2 sm:mb-1" src="assets/icons/Icons/Group.png" alt="Adumo Online">
</div>
